// apps/client/src/components/tags/EntityTagCell.tsx
//
// Tag chips for one lead or client row (eDM plan-v3 core, Slice E3; only
// rendered when `edm_content` is on). `tags` undefined = not loaded yet;
// null = not in the caller's tagging scope (the server returns no tags).

import React from 'react';
import { EDM_UI } from '../../utils/edm';

/** Chips shown before collapsing the rest into "+N". */
export const ENTITY_TAG_CELL_MAX_CHIPS = 3;

const EntityTagCell: React.FC<{ entityId: string; tags: readonly string[] | null | undefined }> = ({
  entityId,
  tags,
}) => {
  const testId = `entity-tags-${entityId}`;
  if (tags === null) {
    return <span data-testid={testId} title="You cannot tag this record" />;
  }
  if (tags === undefined) {
    return (
      <span data-testid={testId} className="text-xs text-gray-600" aria-label="Loading tags">
        …
      </span>
    );
  }
  if (tags.length === 0) {
    return (
      <span data-testid={testId} className="text-xs text-gray-600">
        —
      </span>
    );
  }
  const shown = tags.slice(0, ENTITY_TAG_CELL_MAX_CHIPS);
  const rest = tags.length - shown.length;
  return (
    <span data-testid={testId} className="inline-flex flex-wrap gap-1" title={tags.join(', ')}>
      {shown.map((t) => (
        <span key={t} className={`${EDM_UI.chip} border-blue-500/40 bg-blue-500/10 text-blue-200`}>
          {t}
        </span>
      ))}
      {rest > 0 && <span className={`${EDM_UI.chip} border-gray-600 text-gray-400`}>+{rest}</span>}
    </span>
  );
};

export default EntityTagCell;
